import {
  useState
} from "react";

import api from "../api";

function ModifierReservationModal({
  data,
  onClose
}) {

  const formatDate =
    (d) => {

      if (!d) return "";

      const date =
        new Date(d);

      const year =
        date.getFullYear();

      const month =
        String(
          date.getMonth() +
            1
        ).padStart(2, "0");

      const day =
        String(
          date.getDate()
        ).padStart(2, "0");

      return `${year}-${month}-${day}`;
    };

  const [dateDebut, setDateDebut] =
    useState(
      formatDate(
        data.date_debut
      )
    );

  const [dateFin, setDateFin] =
    useState(
      formatDate(
        data.date_fin_prevue
      )
    );

  const [prix, setPrix] =
    useState(
      data.prix_nuitee_applique ??
        data.prix_nuitee ??
        0
    );

  const [typeOccupation, setTypeOccupation] =
    useState(
        data.type_occupation || "individuel"
    );

  const [nombreOccupants, setNombreOccupants] =
    useState(
        data.nombre_occupants || 1
    );

  const [loading, setLoading] =
    useState(false);


  const handleOccupationChange = (e) => {

      const type = e.target.value;

      setTypeOccupation(type);

      switch (type) {

          case "individuel":
              setNombreOccupants(1);
              break;

          case "couple":
              setNombreOccupants(2);
              break;

          case "famille":
              if (nombreOccupants < 3)
                  setNombreOccupants(3);
              break;

          case "groupe":
              if (nombreOccupants < 5)
                  setNombreOccupants(5);
              break;

          default:
              setNombreOccupants(1);

      }

  };

  // =====================
  // SAVE
  // =====================

  const handleSubmit =
    async () => {

      if (
        !window.confirm(
          "Enregistrer les modifications ?"
        )
      ) {
        return;
      }

      if (
        !window.confirm(
          "Confirmation finale ?"
        )
      ) {
        return;
      }

      setLoading(true);

      try {

        console.log("DATA MODAL =", data);
        console.log("ID UTILISE =", data?.id);
        console.log("SEJOUR_ID =", data?.sejour_id);

        await api.put(
          `/sejours/${data.id}`,
          {
            date_debut:
              formatDate(
                dateDebut
              ),

            date_fin_prevue:
              formatDate(
                dateFin
              ),

            prix_nuitee_applique:
              prix,

            type_occupation: typeOccupation,

            nombre_occupants: nombreOccupants,
          }
        );

        alert(
          "Réservation modifiée"
        );

        onClose();

      } catch (err) {

        console.error(err);

        alert(
          "Erreur modification"
        );

      }

      setLoading(false);
    };

  // =====================
  // DELETE
  // =====================

  const handleCancelReservation =
    async () => {

      if (
        !window.confirm(
          "Annuler cette réservation ?"
        )
      ) {
        return;
      }

      if (
        !window.confirm(
          "Confirmation finale : suppression définitive ?"
        )
      ) {
        return;
      }

      setLoading(true);

      try {

        await api.delete(
          `/sejours/${data.id}`
        );

        alert(
          "Réservation annulée"
        );

        onClose();

      } catch (err) {

        console.error(err);

        alert(
          "Erreur annulation"
        );

      }

      setLoading(false);
    };

  return (
    <div className="p-5 md:p-6 bg-white rounded-2xl shadow-2xl w-full max-w-md mx-auto">

      <h2 className="text-2xl font-bold mb-5 text-center text-gray-800">
        ✏️ Modifier réservation
      </h2>

      {/* DATE DEBUT */}
      <div className="mb-4">

        <label className="block text-sm text-gray-600 mb-2">
          Date de début
        </label>

        <input
          type="date"
          value={
            dateDebut || ""
          }
          min={
            new Date()
              .toISOString()
              .split("T")[0]
          }
          onChange={(e) =>
            setDateDebut(
              e.target.value
            )
          }
          className="w-full border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-500"
        />

      </div>

      {/* DATE FIN */}
      <div className="mb-4">

        <label className="block text-sm text-gray-600 mb-2">
          Date de fin
        </label>

        <input
          type="date"
          value={
            dateFin || ""
          }
          min={dateDebut}
          onChange={(e) =>
            setDateFin(
              e.target.value
            )
          }
          className="w-full border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-500"
        />

      </div>

      {/* PRIX */}
      <div className="mb-5">

        <label className="block text-sm text-gray-600 mb-2">
          Prix appliqué ($)
        </label>

        <input
          type="number"
          value={prix}
          onChange={(e) =>
            setPrix(
              e.target.value
            )
          }
          className="w-full border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-green-500"
        />

      </div>


      {/* OCCUPATION */}

      <div className="mb-5 border rounded-xl p-4 bg-gray-50">

          <h3 className="font-semibold text-gray-700 mb-3">
              👥 Occupation
          </h3>

          <label className="block text-sm text-gray-600 mb-2">
              Type d'occupation
          </label>

          <select
              value={typeOccupation}
              onChange={handleOccupationChange}
              className="w-full border rounded-xl px-4 py-3 mb-4"
          >
              <option value="individuel">Individuel</option>
              <option value="couple">Couple</option>
              <option value="famille">Famille</option>
              <option value="groupe">Groupe</option>
          </select>

          <label className="block text-sm text-gray-600 mb-2">
              Nombre d'occupants
          </label>

          <input
              type="number"
              value={nombreOccupants}
              min={
                  typeOccupation === "famille"
                      ? 3
                      : typeOccupation === "groupe"
                          ? 5
                          : 1
              }
              disabled={
                  typeOccupation === "individuel" ||
                  typeOccupation === "couple"
              }
              onChange={(e) =>
                  setNombreOccupants(
                      Number(e.target.value)
                  )
              }
              className={`w-full border rounded-xl px-4 py-3 ${
                  typeOccupation === "individuel" ||
                  typeOccupation === "couple"
                      ? "bg-gray-100"
                      : ""
              }`}
          />

      </div>
      

      {/* ACTIONS */}
      <div className="flex flex-col gap-3">

        <button
          onClick={onClose}
          className="w-full bg-gray-200 hover:bg-gray-300 transition text-gray-800 py-3 rounded-xl font-semibold"
        >
          ← Retour
        </button>

        <div className="flex flex-col md:flex-row gap-3">

          <button
            onClick={
              handleCancelReservation
            }
            disabled={loading}
            className="flex-1 bg-red-600 hover:bg-red-700 transition text-white py-3 rounded-xl font-semibold disabled:opacity-50"
          >
            ❌ Annuler
          </button>

          <button
            onClick={
              handleSubmit
            }
            disabled={loading}
            className="flex-1 bg-blue-600 hover:bg-blue-700 transition text-white py-3 rounded-xl font-semibold disabled:opacity-50"
          >
            {loading
              ? "Enregistrement..."
              : "💾 Enregistrer"}
          </button>

        </div>

      </div>

    </div>
  );
}

export default ModifierReservationModal;